import type { StaffRole } from '../types/domain.ts'

export function formatTwoDigit(value: number): string {
  if (!Number.isInteger(value) || value < 1 || value > 99) throw new Error('Value must be an integer from 1 to 99.')
  return String(value).padStart(2, '0')
}

export const formatSeasonNumber = formatTwoDigit
export const formatCreatorNumber = formatTwoDigit

export function formatNpcCode(season: number, creator: number, sequence: number): string {
  if (!Number.isInteger(sequence) || sequence < 1 || sequence > 999) throw new Error('Season NPC sequence must be between 1 and 999.')
  return `${formatSeasonNumber(season)}${formatCreatorNumber(creator)}${String(sequence).padStart(3, '0')}`
}

export function isNpcCode(value: string): boolean { return /^\d{7}$/.test(value) }

export function sanitizeScriptId(value: string, fallback = 'npc'): string {
  const sanitized = value.toLowerCase().trim().replace(/[^a-z0-9_]+/g, '_').replace(/^_+|_+$/g, '')
  return sanitized || fallback
}

export function canModify(role: StaffRole): boolean { return role === 'owner' || role === 'editor' }
export function canAdminister(role: StaffRole): boolean { return role === 'owner' }
export function canExport(): boolean { return true }
export function roleLabel(role: StaffRole): string { return role[0].toUpperCase() + role.slice(1) }

export function assertNpcCodeImmutable(previous: string, next: string): void {
  if (previous !== next) throw new Error('NPC code is permanent and cannot be changed by ordinary editing.')
}
